import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { BreadcrumbMenuInterface } from '../interfaces/breadcrumb-menu.interface';
import { BreadcrumbInterface } from '../interfaces/breadcrumb.interface';
import { APP_ROUTES } from '../constants/app-routes.constant';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private breadcrumbMenuSubject = new BehaviorSubject<BreadcrumbMenuInterface>(null);
  private initialBreadcrumbs: BreadcrumbInterface[] = [
    {
      label: 'Inicial',
      url: APP_ROUTES.home.url
    }
  ];
  public breadcrumbs: BreadcrumbInterface[];
  public currentBreadcrumb: BreadcrumbInterface;
  public mobileBreadcrumb: BreadcrumbInterface;
  public breadcrumbMenuObservable: Observable<BreadcrumbMenuInterface>;
  private dynamicBreadcrumbs: any = {};

  constructor(private activatedRoute: ActivatedRoute) {
    this.breadcrumbMenuObservable = this.breadcrumbMenuSubject.asObservable();
  }

  private createBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs = [...this.initialBreadcrumbs]) {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeUrl: string = child.snapshot.url.map((segment) => segment.path).join('/');

      const breadcrumbData = child.snapshot.data['breadcrumb'];

      if (routeUrl !== '') {
        url += `/${routeUrl}`;
      }

      if (breadcrumbData) {
        let dynamicLabel: string;

        if (breadcrumbData.label in this.dynamicBreadcrumbs) {
          dynamicLabel = this.dynamicBreadcrumbs[breadcrumbData.label];

          delete this.dynamicBreadcrumbs[breadcrumbData.label];
        }

        if (dynamicLabel) {
          breadcrumbs.push({ ...breadcrumbData, url, label: dynamicLabel });
        } else {
          breadcrumbs.push({ ...breadcrumbData, url });
        }
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }
  }

  public updateBreadcrumbs() {
    this.breadcrumbs = this.createBreadcrumbs(this.activatedRoute.root).filter(
      (item: BreadcrumbInterface) => !item.skip
    );

    this.currentBreadcrumb = this.breadcrumbs.pop();

    this.mobileBreadcrumb = { ...this.breadcrumbs[this.breadcrumbs.length - 1] };

    if (this.mobileBreadcrumb.label === this.initialBreadcrumbs[0].label) {
      this.mobileBreadcrumb.label = 'Página Inicial';
    }

    this.breadcrumbMenuSubject.next({
      breadcrumbs: this.breadcrumbs,
      currentBreadcrumb: this.currentBreadcrumb,
      mobileBreadcrumb: this.mobileBreadcrumb
    });
  }

  public updateDynamicBreadcrumbs(key: string, value: string) {
    this.dynamicBreadcrumbs[key] = value;

    this.updateBreadcrumbs();
  }
}
